import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-one-one',
  templateUrl: './c4-four-one-one.component.html',
  styleUrls: ['./c4-four-one-one.component.scss']
})
export class C4FourOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
